import { createSlice } from '@reduxjs/toolkit';

export const trainingRequestSlice = createSlice({
  name: 'trainingRequests',
  initialState: {
    requests: []
  },
  reducers: {
    addRequest: (state, { payload }) => ({
      ...state,
      requests: [payload, ...state.requests]
    }),
    clearRequests: (state) => ({
      ...state,
      requests: []
    })
  }
});

export const { addRequest, clearRequests } = trainingRequestSlice.actions;

export const selectRequests = (state) => state.trainingRequests.requests;

export default trainingRequestSlice.reducer;
